// src/components/resources/tools/generators/shared/uploadLimits.ts
//
// Shared client-side upload cap for the resource generators that accept an
// image via FileReader.readAsDataURL (avatar / icon / creative). Capping the
// size before reading avoids storing a multi-MB data URL in React state, which
// can jank or OOM the tab.

/** Maximum accepted upload size for client-side image uploads (10 MB). */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024
